module.exports = __webpack_public_path__ + "static/resume-b70fec9d28e5d750065dfff66619afa5.jpg";